import {html, LitElement} from "lit";
import {customElement, property} from "lit/decorators.js";
import {loadingBoxStyles} from "./LoadingBox.styles.js";

@customElement("pn-loading-box")
export class LoadingBox extends LitElement {
	@property() message: string;
	@property() isOverlay = false;

	static styles = [loadingBoxStyles];

	render() {
		const loading = html`
			<div class="loading-box">
				<div class="animation">
					<div class="animation-item animation-item-1"></div>
					<div class="animation-item animation-item-2"></div>
					<div class="animation-item animation-item-3"></div>
					<div class="animation-item animation-item-4"></div>
				</div>
				${this.message ? html`<span>${this.message}</span>` : null}
			</div>
		`;

		if (!this.isOverlay)
			return loading;

		return html`
			<div class="loading-box-overlay">
				${loading}
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-loading-box": LoadingBox;
	}
}
